import { render } from "./touchspin_Form.vue?vue&type=template&id=4f9da20b"
import script from "./touchspin_Form.vue?vue&type=script&lang=js"
export * from "./touchspin_Form.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__